require('@/core/http')
require('@/components/dialog')

import Vue from 'vue'
import ElementUI from 'element-ui'
//import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/custom/index.scss'
import '@/core/config/global.js'
import App from './App'
import router from './router'
import store from './store'
import vuescroll from 'vuescroll'
import TreeSelect from '@/components/TreeSelect';
import RichEditor from '@/components/UEditor';
import InputNumberRange from '@/components/InputNumberRange';
import LineChart from '@/components/LineChart';
import BarChart from '@/components/BarChart';
import PieChart from '@/components/PieChart';
import DateRange from '@/components/DateRange';
import VCharts from 'v-charts';

Vue.component('tree-select', TreeSelect);
Vue.component('rich-editor', RichEditor);
Vue.component('number-range', InputNumberRange);
Vue.component('line-chart', LineChart);
Vue.component('bar-chart', BarChart);
Vue.component('pie-chart', PieChart);
Vue.component('date-range', DateRange);

Vue.use(ElementUI)
Vue.use(vuescroll)
Vue.use(VCharts)

Vue.config.productionTip = false

new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js